import React from 'react'
import classNames from 'classnames'

import isSameDay from 'date-fns/isSameDay';

const baseHeight = 2;

export default function Day({
    day,
    selectedDates,
    onSelect,
    onChange,
    hasSchedule,
    scheduleLength,
}) {

    function selectDayHandler() {

        // if (isBefore(date, new Date()) && !isSameDay(date, new Date())) {
        //     return
        // }

        // if (!selectedDates || !selectedDates.checkin) {
        //     if (onChange && typeof onChange === 'function') {
        //         onChange({ day: date, type: 'checkin' })
        //     }
        //     return onSelect({
        //         checkin: date,
        //         checkout: null
        //     })
        // }

        // if(selectedDates?.checkin && !selectedDates.checkout) {
        //     if (isBefore(date, selectedDates?.checkin)) {
        //         onChange({ day: date, type: 'checkin' })
        //         return onSelect({
        //             checkin: date,
        //             checkout: null
        //         })
        //     }
        //     if (onChange && typeof onChange === 'function') {
        //         onChange({ day: date, type: 'checkout' })
        //     }
        //     return onSelect({
        //         ...selectedDates,
        //         checkout: date
        //     })
        // }
           
        // if (selectedDates?.checkin && selectedDates?.checkout) {
        //     if (onChange && typeof onChange === 'function') {
        //         onChange({ day: date, type: 'checkin' })
        //     }
        //     return onSelect({
        //         checkin: date,
        //         checkout: null
        //     })
        // }

        let payload = [...selectedDates || []];

        if(selectedDates?.length === 2) {
            payload = [day.date];
        }

        if(selectedDates?.length === 1) {
            payload = [
                ...payload,
                day.date
            ];
        }

        if(selectedDates?.length === 0) {
            payload = [day.date];
        }

        payload = payload.sort((a, b) => a - b);

        if(onChange && typeof onChange === 'function') {
            onChange(payload)
        }

        return onSelect(payload)
    }

    const { isCheckin, isCheckout, isSelected, isIncluded } = day;

    const DayClasses = classNames({
        "ola-day flex relative items-center box-border cursor-pointer": true,
        "hover:bg-light": !isCheckin && !isCheckout && !isSelected && !isIncluded,
        "aspect-square justify-center": !hasSchedule,
        "h-full flex-col py-2 border-r border-gray": hasSchedule,
        "border-l": hasSchedule && day.weekDay !== 0 && day.day === '01',
        "last:border-0": hasSchedule && day.weekDay === 6,
        "opacity-20": day.isPast && !isSameDay(day.date, new Date()) && !hasSchedule,
        "bg-lightprimary": isIncluded && !isSelected,
        "bg-dark text-white": isSelected,
        "rounded-l-xl rounded-r-0": isCheckin,
        "rounded-r-xl rounded-l-0": isCheckout,
        // "rounded-xl": isSameDay(selectedDays?.[0], selectedDays?.[1]) || (selectedDays?.[0] && !selectedDays?.[1])
    })

    return (
        <div
            className={DayClasses}
            style={{
                width: 'calc(100% / 7)',
                paddingBottom: hasSchedule && `${baseHeight * scheduleLength}rem`,
                aspectRatio: !hasSchedule && '1 / 1'
            }}
            onClick={!hasSchedule ? selectDayHandler : undefined}
        >
            {day.day}
        </div>
    )
}